import { Work } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class WorkOfflineDataUpdateCacher extends OfflineDataUpdateCacher<Work> {
    constructor() {
        super(dbCacheUp.work)
    }
}